import * as yup from "yup";

import i18n from "core/i18n";
import pageContext from "core/pageContext";

const LICENCE_PLATE_FORMAT_CZ = new RegExp("^[0-9A-Z]{5,8}$");
const LICENCE_PLATE_FORMAT_SK = new RegExp("^[0-9A-Z]{5,7}$");

const VEHICLE_LICENCE_FORMAT_CZ = new RegExp("^[A-Z]{2,3}[0-9]{6}$");
const VEHICLE_LICENCE_FORMAT_SK = new RegExp("^[A-Z]{2}[0-9]{6}$");

export default function getValidationSchema() {
    const { t } = i18n.useTranslation();
    const { isSlovakSite } = pageContext.useGetPageLocalization();

    let today = new Date();
    today = new Date(today.setHours(0, 0, 0, 0));

    const validationSchema = yup.object().shape({
        idChange: yup.string().nullable(),
        vinNumber: yup.string().nullable(),
        validityStartDate: yup.date().typeError(t("error.notValid")).min(today, t("error.notValid")).required(t("error.required")),
        isLicencePlateNumberChange: yup.boolean(),
        isVehicleLicenceNumberChange: yup.boolean(),
        newLicencePlateNumber: yup.string().when("isLicencePlateNumberChange", {
            is: true,
            then: (schema) =>
                schema
                    .required(t("error.required"))
                    .test({
                        name: "isDifferent",
                        message: t("error.mustBeDifferent"),
                        test: function (value) {
                            const { oldLicencePlateNumber } = this.parent;
                            return value !== oldLicencePlateNumber;
                        },
                    })
                    .test({
                        name: "correctValue",
                        message: t("error.notValid"),
                        test: function (value) {
                            return isSlovakSite ? LICENCE_PLATE_FORMAT_SK.test(value) : LICENCE_PLATE_FORMAT_CZ.test(value);
                        },
                    }),
            otherwise: (schema) => schema.nullable(),
        }),
        newVehicleLicenceNumber: yup.string().when("isVehicleLicenceNumberChange", {
            is: true,
            then: (schema) =>
                schema
                    .required(t("error.required"))
                    .test({
                        name: "isDifferent",
                        message: t("error.mustBeDifferent"),
                        test: function (value) {
                            const { oldVehicleLicenceNumber } = this.parent;
                            return value !== oldVehicleLicenceNumber;
                        },
                    })
                    .test({
                        name: "correctValue",
                        message: t("error.notValid"),
                        test: function (value) {
                            return isSlovakSite ? VEHICLE_LICENCE_FORMAT_SK.test(value) : VEHICLE_LICENCE_FORMAT_CZ.test(value);
                        },
                    }),
            otherwise: (schema) => schema.nullable(),
        }),
        oldLicencePlateNumber: yup.string().when(["isLicencePlateNumberChange", "$isAuthenticated"], {
            is: (isChanged: boolean, isAuthenticated: boolean) => isChanged && !isAuthenticated,
            then: (schema) =>
                schema.required(t("error.required")).test({
                    name: "correctValue",
                    message: t("error.notValid"),
                    test: function (value) {
                        return isSlovakSite ? LICENCE_PLATE_FORMAT_SK.test(value) : LICENCE_PLATE_FORMAT_CZ.test(value);
                    },
                }),
            otherwise: (schema) => schema.nullable(),
        }),
        oldVehicleLicenceNumber: yup.string().when(["isVehicleLicenceNumberChange", "$isAuthenticated"], {
            is: (isChanged: boolean, isAuthenticated: boolean) => isChanged && !isAuthenticated,
            then: (schema) =>
                schema.required(t("error.required")).test({
                    name: "correctValue",
                    message: t("error.notValid"),
                    test: function (value) {
                        return isSlovakSite ? VEHICLE_LICENCE_FORMAT_SK.test(value) : VEHICLE_LICENCE_FORMAT_CZ.test(value);
                    },
                }),
            otherwise: (schema) => schema.nullable(),
        }),
        email: yup.string().email().nullable(),
    });

    return validationSchema;
}
